"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getJwPlayerVersion = void 0;
var getJwPlayerVersion = function (version) {
    var _a;
    return ((_a = version.match(/([0-9]+)\.([0-9]+)\.([0-9]+)/g)) === null || _a === void 0 ? void 0 : _a[0]) || '';
};
exports.getJwPlayerVersion = getJwPlayerVersion;
